// import React, { useMemo, useState } from 'react';
// import SelectBox from '../../shared/controls/form/selectBox';
// import closeSqr from '../../../src/assets/img/crm_home/main-content/close-square.svg';
// import useLeadColumnDefs from '../leads/useLeadColumnDefs';
// import { TextBox } from '../../shared/controls/form';
// import { Form, Formik } from 'formik';
// import { useSelector } from 'react-redux';
// import { getActiveOwners, getGenericMasterFilteredListByKey } from '../../redux/selector';
// import Select from 'react-select';
// import apiServices from '../../services/service';
// import { toast } from 'react-toastify';

// const AudienceFilter = ({
//   formData,
//   handleSubmit,

//   handleChangeForm,
//   handleDateTime,
//   errormsg,
// }) => {
//   // ✅ Call useLeadColumnDefs with dummy/static props if not needed here
//   const columnDefs = useLeadColumnDefs({
//     hasUpdateLeadPermission: false,
//     hasInfoLeadPermission: false,
//     hasDeleteLeadPermission: false,
//     emailPopup: () => {},
//     gridData: {},
//     handleClickDelete: () => {},
//     leadSourceDropdown: [],
//     industryTypeDropdown: [],
//     campaignListDropdown: [],
//     tagsList: [],
//     salutation: [],
//     revenueTypeDropdown: [],
//     timeZoneList: [],
//     owner: [],
//   });
//   const owner = useSelector(getActiveOwners);
//   const revenueTypeDropdown = useSelector(getGenericMasterFilteredListByKey('RevenueType'));
//   const industryTypeDropdown = useSelector(getGenericMasterFilteredListByKey('Industry'));
//   const leadSourceDropdown = useSelector(getGenericMasterFilteredListByKey('LeadSource'));
//   const salutation = useSelector(getGenericMasterFilteredListByKey('Salutation'));
//   const timeZoneList = useSelector(getGenericMasterFilteredListByKey('TimeZone'));

//   const [selectedOption, setSelectedOption] = useState(null);
//   const [isSelectedOption, setIsSelectedOption] = useState(false);
//   const [selectedFilterType, setSelectedFilterType] = useState();
//   const [selectedOptions, setSelectedOptions] = useState();
//   const [fieldValues, setFieldValues] = useState({});
// const [filteredResult, setFilteredResult] = useState()

//   const filterOptions = useMemo(
//     () =>
//       columnDefs
//         .filter((col) => col.headerName && col.field)
//         .map((col, index) => ({
//           id: index + 1,
//           label: col.headerName,
//           value: col.field,
//           originalData: col,
//         })),
//     [columnDefs]
//   );

//   const filter = [
//     { id: 1, filter: 'Industry' },
//     { id: 2, filter: 'Geography' },
//   ];
//   const filter2 = [
//     { id: 1, label: 'Equals', value: 'equals' },
//     { id: 2, label: 'Not Equals', value: 'notEquals' },
//     { id: 3, label: 'Greater Than', value: 'greaterThan' },
//     { id: 4, label: 'Greater Than Or Equal', value: 'greaterThanOrEqual' },
//     { id: 5, label: 'Less Than', value: 'lessThan' },
//     { id: 6, label: 'Less Than Or Equal', value: 'lessThanOrEqual' },
//     { id: 7, label: 'Contains', value: 'contains' },
//   ];
//   const handleChange = (selectedOption, name) => {
//     setSelectedOptions((prevState) => ({
//       ...prevState,
//       [name]: selectedOption,
//     }));

//     handleLookupDropDownChange(selectedOption.value, selectedOption, name);
//   };

//   const handleLookupDropDownChange = (selectedId, selectedOption, name) => {
//     const selectedValue = selectedOption.label;

//     if (name === 'conditionOperator') {
//       setSelectedFilterType({

//         conditionOperator: selectedValue,

//       });

//     }

//   };

//   const valueOptions = [
//     { id: 1, label: 'Technology' },
//     { id: 2, label: 'Healthcare' },
//     { id: 3, label: 'Finance' },
//     { id: 4, label: 'Manufacturing' },
//   ];
//   // ✅ Determine selected column details
//   const selectedColumn = filterOptions.find((col) => col.label === selectedOptions?.filter);
//   const selectedType = selectedColumn?.type || 'text';
//   const selectedField = selectedColumn?.field?.toLowerCase() || '';
//   const handleChangeCheckbox = (e) => {
//     const { name, checked } = e.target; // Use 'checked' for true/false value

//     setFieldValues((prevValues) => ({
//       ...prevValues,
//       [name]: checked, // Set the checkbox state as true/false
//     }));
//   };

//   const handleDropdownChange = (selected, fieldName) => {
//     const value = selected.value;
//     setFieldValues((prevValues) => ({
//       ...prevValues,
//       [fieldName]: value,
//     }));

//     console.log(`Dropdown selected: ${value}`);
//   };
//   const handleInputChange = (e, fieldName) => {
//     debugger
//     const value = e.target.value;
//     // For other fields, directly update the state
//     setFieldValues((prevValues) => ({
//       ...prevValues,
//       [fieldName]: value,
//     }));
//   };

//   const handleSelection = (selectedOption) => {
//     debugger;
//     debugger;
//     if (!selectedOption) return;

//     setIsSelectedOption(true);
//     setFieldValues({});

//     const { label, value, originalData } = selectedOption;
//     const headerName = originalData?.headerName || label;

//     // ✅ Mapping of headerName → dropdown source
//     const headerDataMap = {
//       'Lead Source': leadSourceDropdown,
//       'Lead Owner': owner,
//       Industry: industryTypeDropdown,
//       'Time Zone': timeZoneList,
//       Salutation: salutation,
//       'Revenue Type': revenueTypeDropdown,
//     };

//     // ✅ Attach relevant data array if exists
//     if (headerDataMap[headerName]) {
//       selectedOption.originalData.data = headerDataMap[headerName];
//     }

//     // ✅ Handle checkbox-specific setup
//     if (headerName === 'Email Opt Out') {
//       setFieldValues((prev) => ({ ...prev, emailOptOut: false }));
//     }

//     // ✅ Save the entire selection for rendering
//     setSelectedOption(selectedOption);
//   };

//     const handleApplyFilter = async () => {
//         debugger
//   try {
//     // Basic validations
//     if (!selectedOption) {
//       toast.error('Please select a field to filter.', { position: 'top-right' });
//       return;
//     }
//     if (!selectedFilterType?.conditionOperator) {
//       toast.error('Please select a condition operator.', { position: 'top-right' });
//       return;
//     }

//     // Determine filter value
//    const filterValue =
//   fieldValues[selectedOption.value] ||           // ✅ correct key
//   fieldValues[`${selectedOption.value}Id`] ||    // for dropdown fields
//   fieldValues.emailOptOut?.toString() ||         // for checkbox
//   '';

//     if (!filterValue) {
//       toast.error('Please enter a filter value.', { position: 'top-right' });
//       return;
//     }

//     // ✅ Construct the JSON body
//     const result = {
//       id: formData.id, // you can pass dynamic id if needed
//       targetModule: 'Lead', // or dynamic from props if needed
//       audienceFilter: {
//         aggregateOperator: 'AND', // or 'OR' if multiple filters are combined later
//         filters: [
//           {
//             fieldName: selectedOption.value.charAt(0).toUpperCase() + selectedOption.value.slice(1), // the selected field
//             conditionOperator: selectedFilterType.conditionOperator, // Equals, Contains, etc.
//             filterValue: filterValue.toString(), // always string
//           },
//         ],
//       },
//     };

//     console.log('🚀 Filter Payload:', result);

//     // ✅ Call API
//     const response = await apiServices.SmartSquenceAudienceFilter(result);

//     if (response.status === 200 || response.data?.success) {
//       toast.success('Audience filter applied successfully!', { position: 'top-right' });
//       setFilteredResult(response.data)
//     } else {
//       toast.error('Failed to apply filter. Please try again.', { position: 'top-right' });
//       console.error('❌ API Error:', response);
//     }
//   } catch (error) {
//     toast.error('An unexpected error occurred.', { position: 'top-right' });
//     console.error('❌ Exception:', error);
//   }
// };

//   return (
//     <Formik initialValues={formData}>
//       <Form>
//         <div>
//           <div className="formBlock" style={{ height: 'calc(100vh - 190px)' }}>
//             <div className="frmHdr">
//               <h2>Filter Builder</h2>
//             </div>

//             <div className="counterBlock">
//               <p>{filteredResult} Records</p>
//             </div>

//             <div className="formContent filterBlk mt-3">
//               <div className="row">
//                 <div className="col-12 col-sm-6 col-md-6 col-lg-4">
//                   <div className="input-container">
//                     <label htmlFor="filter1"></label>
//                     <Select
//                       value={isSelectedOption ? selectedOption : null}
//                       options={columnDefs?.map((data) => ({
//                         value: data.field,
//                         label: data.headerName,
//                         originalData: data,
//                       }))}
//                       onChange={(selectedOption) => handleSelection(selectedOption)}
//                       menuShouldScrollIntoView={false}
//                       disabled={'timeZoneId'}
//                       placeholder={'Select Field'}
//                       styles={{
//                         control: (base, state) => ({
//                           ...base,
//                           borderRadius: '5px',
//                           borderColor: state.isFocused ? '#365397' : base.borderColor,
//                           borderWidth: state.isFocused ? '1px' : base.borderWidth,
//                           boxShadow: state.isFocused ? '0 0 5px rgba(0, 86, 179, 0.3)' : 'none',
//                           transition: 'border-color 0.3s ease, box-shadow 0.3s ease',
//                           '&:hover': {
//                             borderColor: '#365397',
//                           },
//                         }),
//                         menu: (base) => ({
//                           ...base,
//                           borderRadius: '5px',
//                           zIndex: 99999,
//                         }),
//                         menuPortal: (base) => ({
//                           ...base,
//                           zIndex: 9999,
//                         }),
//                         option: (base, state) => ({
//                           ...base,
//                           backgroundColor: state.isSelected
//                             ? '#DEEBFF'
//                             : state.isFocused
//                               ? '#DEEBFF'
//                               : base.backgroundColor,
//                           color: state.isSelected ? '#222' : state.isFocused ? '#222' : base.color,
//                           cursor: 'pointer',
//                         }),
//                       }}
//                       menuPortalTarget={document.body}
//                     />
//                   </div>
//                 </div>
//                 <div className="col-12 col-sm-6 col-md-6 col-lg-3">
//                   <div className="input-container">
//                     <SelectBox
//                       label={''}
//                       name={'conditionOperator'}
//                       placeholder={'Select'}
//                       selectedOptions={selectedOptions?.conditionOperator}
//                       handleSelect={handleChange}
//                       options={filter2}
//                       optionKeys={['id', 'label']}
//                       errormsg={errormsg?.conditionOperator}
//                     />
//                   </div>
//                 </div>
//                 <div className="col-11 col-sm-11 col-md-11 col-lg-4">
//                   <div className="input-container">
//                     {selectedOption && isSelectedOption ? (
//                       selectedOption.originalData.type === 'text' ? (
//                         <input
//                           type="text"
//                           placeholder={`Enter ${selectedOption.label}`}
//                           value={fieldValues[selectedOption.value] || ''}
//                           onChange={(e) => handleInputChange(e, selectedOption.value)}
//                           style={{
//                             width: '100%',
//                             height: '40px',
//                             borderRadius: '5px',
//                             border: '1px solid #ccc', // Matches Select border color
//                             padding: '8px 12px', // Matches Select padding
//                             marginTop: '8px',
//                             fontSize: '16px',
//                             outline: 'none',
//                             transition: 'border-color 0.3s, box-shadow 0.3s',
//                           }}
//                           onFocus={(e) => {
//                             e.target.style.borderColor = '#365397'; // Focus border color
//                             e.target.style.boxShadow = '0 0 5px rgba(0, 86, 179, 0.3)'; // Focus box-shadow
//                           }}
//                           onBlur={(e) => {
//                             e.target.style.borderColor = '#ccc'; // Reset border color on blur
//                             e.target.style.boxShadow = 'none'; // Remove box-shadow on blur
//                           }}
//                         />
//                       ) : selectedOption.originalData.type === 'dropdown' ? (
//                         <>
//                           <label htmlFor="filter3"></label>
//                           <Select
//                             value={
//                               fieldValues[`${selectedOption?.value}Id`] // Check if there's a value in the state for the selected option
//                                 ? {
//                                     value: fieldValues[`${selectedOption?.value}Id`],
//                                     label:
//                                       selectedOption.originalData.data?.find(
//                                         (data) =>
//                                           data.id === fieldValues[`${selectedOption?.value}Id`] ||
//                                           (data.userId &&
//                                             data.userId ===
//                                               fieldValues[`${selectedOption?.value}Id`]) // Check both `id` and `userId` properly
//                                       )?.displayName ||
//                                       selectedOption.originalData.data?.find(
//                                         (data) =>
//                                           data.id === fieldValues[`${selectedOption?.value}Id`] ||
//                                           (data.userId &&
//                                             data.userId ===
//                                               fieldValues[`${selectedOption?.value}Id`])
//                                       )?.display_name ||
//                                       '',
//                                   }
//                                 : null // If no value, set null to reset
//                             }
//                             options={
//                               selectedOption.originalData.data?.map((data) => ({
//                                 value: data.id ? data.id : data.userId,
//                                 label: data.displayName ? data.displayName : data.display_name,
//                               })) || []
//                             }
//                             disabled
//                             placeholder={`Select ${selectedOption.label}`}
//                             menuPortalTarget={document.body} // Ensures the dropdown renders outside the modal
//                             styles={{
//                               control: (base, state) => ({
//                                 ...base,
//                                 borderRadius: '5px',
//                                 //   marginTop: '14px',
//                                 borderColor: state.isFocused ? '#365397' : base.borderColor,
//                                 borderWidth: state.isFocused ? '1px' : base.borderWidth,
//                                 boxShadow: state.isFocused
//                                   ? '0 0 5px rgba(0, 86, 179, 0.3)'
//                                   : 'none',
//                                 transition: 'border-color 0.3s ease, box-shadow 0.3s ease',
//                                 '&:hover': {
//                                   borderColor: '#365397',
//                                 },
//                               }),

//                               menu: (base) => ({
//                                 ...base,
//                                 borderRadius: '5px',
//                                 zIndex: 99999,
//                               }),
//                               menuPortal: (base) => ({
//                                 ...base,
//                                 zIndex: 99999,
//                               }),
//                               option: (base, state) => ({
//                                 ...base,
//                                 backgroundColor: state.isFocused ? '#365397' : base.backgroundColor,
//                                 color: state.isFocused ? '#fff' : base.color,
//                                 cursor: 'pointer',
//                               }),
//                               singleValue: (base) => ({
//                                 ...base,
//                                 padding: '2px 4px',
//                                 borderRadius: '3px',
//                               }),
//                             }}
//                             onChange={(selected) =>
//                               handleDropdownChange(selected, `${selectedOption.value}Id`)
//                             }
//                           />
//                         </>
//                       ) : selectedOption.originalData.type === 'number' ? (
//                         <div
//                           style={{
//                             display: 'flex',
//                             alignItems: 'center',
//                             marginTop: '14px',
//                             position: 'relative',
//                           }}
//                         >
//                           {/* Input wrapper with relative position */}
//                           {selectedOption.originalData.headerName === 'Annual Revenue' && (
//                             <div
//                               style={{
//                                 position: 'relative',
//                                 width: '100%',
//                               }}
//                             >
//                               {/* Dollar symbol inside the input box */}
//                               <span
//                                 style={{
//                                   position: 'absolute',
//                                   left: '10px',
//                                   top: '50%',
//                                   transform: 'translateY(-50%)',
//                                   fontSize: '16px',
//                                   color: '#888',
//                                   pointerEvents: 'none',
//                                 }}
//                               >
//                                 $
//                               </span>
//                               <input
//                                 type="number"
//                                 placeholder={`Enter ${selectedOption.label}`}
//                                 value={fieldValues[selectedOption.value] || ''}
//                                 onChange={(e) => {
//                                   // Enforce number limit conditionally for "Mobile"
//                                   const value = e.target.value;
//                                   if (
//                                     selectedOption.originalData.headerName === 'Mobile' &&
//                                     value.length > 15
//                                   ) {
//                                     return; // Prevent further input if length exceeds limit
//                                   }
//                                   handleInputChange(e, selectedOption.value); // Call your change handler
//                                 }}
//                                 style={{
//                                   width: '100%',
//                                   height: '40px',
//                                   borderRadius: '5px',
//                                   border: '1px solid #ccc',
//                                   padding: '8px 12px 8px 30px', // Add padding-left to account for the dollar symbol
//                                   fontSize: '16px',
//                                   outline: 'none',
//                                   transition: 'border-color 0.3s, box-shadow 0.3s',
//                                 }}
//                                 onFocus={(e) => {
//                                   e.target.style.borderColor = '#365397';
//                                   e.target.style.boxShadow = '0 0 0 1px #365397';
//                                 }}
//                                 onBlur={(e) => {
//                                   e.target.style.borderColor = '#ccc';
//                                   e.target.style.boxShadow = 'none';
//                                 }}
//                               />
//                             </div>
//                           )}
//                           {/* Input without the dollar sign for other cases */}
//                           {selectedOption.originalData.headerName !== 'Annual Revenue' && (
//                             <input
//                               type="number"
//                               placeholder={`Enter ${selectedOption.label}`}
//                               value={fieldValues[selectedOption.value] || ''}
//                               onChange={(e) => {
//                                 const value = e.target.value;
//                                 if (
//                                   selectedOption.originalData.headerName === 'Mobile' &&
//                                   value.length > 15
//                                 ) {
//                                   return;
//                                 }
//                                 handleInputChange(e, selectedOption.value);
//                               }}
//                               style={{
//                                 width: '100%',
//                                 height: '40px',
//                                 borderRadius: '5px',
//                                 border: '1px solid #ccc',
//                                 padding: '8px 12px',
//                                 fontSize: '16px',
//                                 outline: 'none',
//                                 transition: 'border-color 0.3s, box-shadow 0.3s',
//                               }}
//                               onFocus={(e) => {
//                                 e.target.style.borderColor = '#365397';
//                                 e.target.style.boxShadow = '0 0 0 1px #365397';
//                               }}
//                               onBlur={(e) => {
//                                 e.target.style.borderColor = '#ccc';
//                                 e.target.style.boxShadow = 'none';
//                               }}
//                             />
//                           )}
//                         </div>
//                       ) : selectedOption.originalData.type === 'checkbox' ? (
//                         <div className="input-container" id="flex-clumn">
//                           <span>Email Opt Out</span>
//                           <input
//                             type="checkbox"
//                             label={'Email Opt Out'}
//                             name={'emailOptOut'}
//                             onChange={handleChangeCheckbox}
//                           />
//                         </div>
//                       ) : (
//                         <></>
//                       )
//                     ) : (
//                       <></>
//                     )}
//                   </div>
//                 </div>
//                 <div className="col-1 col-sm-1 col-md-1 col-lg-1">
//                   <div className="closeSqrBtn">
//                     <img src={closeSqr} alt="" />
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <button className="btn btn-outline-primary"  onClick={handleApplyFilter}>
//               <i className="bi bi-plus-lg" ></i> Add Filter
//             </button>
//           </div>
//         </div>
//       </Form>
//     </Formik>
//   );
// };

// export default AudienceFilter;

import React, { useEffect, useMemo, useState } from 'react';
import SelectBox from '../../shared/controls/form/selectBox';
import closeSqr from '../../../src/assets/img/crm_home/main-content/close-square.svg';
import useLeadColumnDefs from '../leads/useLeadColumnDefs';
import { Form, Formik } from 'formik';
import { useSelector } from 'react-redux';
import { getActiveOwners, getGenericMasterFilteredListByKey } from '../../redux/selector';
import Select from 'react-select';
import apiServices from '../../services/service';
import { toast } from 'react-toastify';
import { set } from 'date-fns';

const AudienceFilter = ({ formData, handleSubmit, handleChangeForm, handleDateTime, errormsg }) => {
  const columnDefs = useLeadColumnDefs({
    hasUpdateLeadPermission: false,
    hasInfoLeadPermission: false,
    hasDeleteLeadPermission: false,
    emailPopup: () => {},
    gridData: {},
    handleClickDelete: () => {},
    leadSourceDropdown: [],
    industryTypeDropdown: [],
    campaignListDropdown: [],
    tagsList: [],
    salutation: [],
    revenueTypeDropdown: [],
    timeZoneList: [],
    owner: [],
  });

  // Excluded column header names
  const excludedHeaders = [
    'createdDateTime',
    'updatedDateTime',
    'createdBy',
    'updatedBy',
    'Tags',
    'description',
    'title',
    'salutation',
  ];

  const filteredColumnDefs = useMemo(() => {
    return columnDefs.filter(
      (col) =>
        col.headerName &&
        !excludedHeaders.some(
          (excluded) =>
            col.headerName.toLowerCase() === excluded.toLowerCase() ||
            col.field?.toLowerCase() === excluded.toLowerCase()
        )
    );
  }, [columnDefs]);

  const owner = useSelector(getActiveOwners);
  const revenueTypeDropdown = useSelector(getGenericMasterFilteredListByKey('RevenueType'));
  const industryTypeDropdown = useSelector(getGenericMasterFilteredListByKey('Industry'));
  const leadSourceDropdown = useSelector(getGenericMasterFilteredListByKey('LeadSource'));
  const salutation = useSelector(getGenericMasterFilteredListByKey('Salutation'));
  const timeZoneList = useSelector(getGenericMasterFilteredListByKey('TimeZone'));
  const [selectedOptions, setSelectedOptions] = useState();
  const [selectedFilterType, setSelectedFilterType] = useState();

  // ✅ multiple filters support
  const [filterRows, setFilterRows] = useState([
    {
      selectedOption: null,
      isSelectedOption: false,
      selectedFilterType: null,
      fieldValues: {},
    },
  ]);

  const [filteredResult, setFilteredResult] = useState(formData?.recordCount);
  const [loading, setLoading] = useState(false);

  const filter2 = [
    { id: 1, label: 'Equals', value: 'equals' },
    { id: 2, label: 'Not Equals', value: 'notEquals' },
    { id: 3, label: 'Greater Than', value: 'greaterThan' },
    { id: 4, label: 'Greater Than Or Equal', value: 'greaterThanOrEqual' },
    { id: 5, label: 'Less Than', value: 'lessThan' },
    { id: 6, label: 'Less Than Or Equal', value: 'lessThanOrEqual' },
    { id: 7, label: 'Contains', value: 'contains' },
  ];

  const handleSelection = (selectedOption, rowIndex) => {
    const updatedRows = [...filterRows];
    if (!selectedOption) return;

    updatedRows[rowIndex].isSelectedOption = true;
    updatedRows[rowIndex].fieldValues = {};

    const { label, value, originalData } = selectedOption;
    const headerName = originalData?.headerName || label;

    const headerDataMap = {
      'Lead Source': leadSourceDropdown,
      'Lead Owner': owner,
      Industry: industryTypeDropdown,
      'Time Zone': timeZoneList,
      Salutation: salutation,
      'Revenue Type': revenueTypeDropdown,
    };

    if (headerDataMap[headerName]) {
      selectedOption.originalData.data = headerDataMap[headerName];
    }

    if (headerName === 'Email Opt Out') {
      updatedRows[rowIndex].fieldValues.emailOptOut = false;
    }

    updatedRows[rowIndex].selectedOption = selectedOption;
    setFilterRows(updatedRows);
  };

  //   const handleChange = (selectedOption, name, rowIndex) => {
  //     const updatedRows = [...filterRows];
  //     updatedRows[rowIndex].selectedFilterType = { conditionOperator: selectedOption.label };
  //     setFilterRows(updatedRows);
  //   };

  const handleInputChange = (e, fieldName, rowIndex) => {
    const value = e.target.value;
    const updatedRows = [...filterRows];
    updatedRows[rowIndex].fieldValues = {
      ...updatedRows[rowIndex].fieldValues,
      [fieldName]: value,
    };
    setFilterRows(updatedRows);
  };

  const handleChange = (selectedOption, name, rowIndex) => {
    // Clone the rows array
    const updatedRows = [...filterRows];

    // Make sure the row exists
    if (!updatedRows[rowIndex]) {
      updatedRows[rowIndex] = {
        selectedOption: null,
        isSelectedOption: false,
        selectedFilterType: null,
        fieldValues: {},
      };
    }

    // Update the selected option for this row
    updatedRows[rowIndex].selectedOptions = {
      ...updatedRows[rowIndex].selectedOptions,
      [name]: selectedOption,
    };

    setFilterRows(updatedRows);

    // Call your original lookup function with row index
    handleLookupDropDownChange(selectedOption.value, selectedOption, name, rowIndex);
  };

  const handleLookupDropDownChange = (selectedId, selectedOption, name, rowIndex) => {
    const selectedValue = selectedOption.label;

    // Clone again to update this row
    const updatedRows = [...filterRows];

    if (!updatedRows[rowIndex]) return;

    if (name === 'conditionOperator') {
      updatedRows[rowIndex].selectedFilterType = {
        conditionOperator: selectedValue,
      };
    }

    setFilterRows(updatedRows);
  };

  const handleDropdownChange = (selected, fieldName, rowIndex) => {
    const value = selected.value;
    const updatedRows = [...filterRows];
    updatedRows[rowIndex].fieldValues = {
      ...updatedRows[rowIndex].fieldValues,
      [fieldName]: value,
    };
    setFilterRows(updatedRows);
  };

  const handleChangeCheckbox = (e, rowIndex) => {
    const { name, checked } = e.target;
    const updatedRows = [...filterRows];
    updatedRows[rowIndex].fieldValues = {
      ...updatedRows[rowIndex].fieldValues,
      [name]: checked,
    };
    setFilterRows(updatedRows);
  };

  const handleAddFilter = () => {
    setFilterRows([
      ...filterRows,
      {
        selectedOption: null,
        isSelectedOption: false,
        selectedFilterType: null,
        fieldValues: {},
      },
    ]);
  };

  const handleRemoveFilter = (index) => {
    setFilterRows((prev) => prev.filter((_, i) => i !== index));
  };

  const handleApplyFilter = async (e) => {
    e.preventDefault();

    const filtersPayload = filterRows
      .map((row) => {
        if (
          !row.selectedOption ||
          !row.selectedFilterType ||
          !Object.keys(row.fieldValues).length
        ) {
          return null;
        }

        const selectedOption = row.selectedOption;
        const originalData = selectedOption.originalData || {};
        const fieldType = originalData.type;
        const baseFieldName = selectedOption.value;

        let fieldName = baseFieldName;
        let filterValue = '';

        // ✅ For dropdown fields
        if (fieldType === 'dropdown') {
          const fieldKey = `${baseFieldName}Id`;
          const valueId = row.fieldValues[fieldKey] || row.fieldValues[`${baseFieldName}Id`];

          fieldName = baseFieldName.charAt(0).toUpperCase() + baseFieldName.slice(1) + 'Id';
          filterValue = valueId ? valueId.toString() : '';
        }
        // ✅ For checkbox fields
        else if (fieldType === 'checkbox') {
          filterValue = row.fieldValues.emailOptOut ? 'true' : 'false';
          fieldName = baseFieldName.charAt(0).toUpperCase() + baseFieldName.slice(1);
        }
        // ✅ For text/number fields
        else {
          const value =
            row.fieldValues[baseFieldName] || row.fieldValues[`${baseFieldName}Id`] || '';
          filterValue = value.toString();
          fieldName = baseFieldName.charAt(0).toUpperCase() + baseFieldName.slice(1);
        }

        if (!filterValue) return null;

        return {
          fieldName,
          conditionOperator: row.selectedFilterType.conditionOperator,
          filterValue,
        };
      })
      .filter(Boolean);

    if (!filtersPayload.length) {
      toast.error('Please fill all filters before applying.', {
        position: 'top-right',
      });
      return;
    }

    const result = {
      id: formData.id,
      targetModule: 'Lead',
      audienceFilter: {
        aggregateOperator: 'AND',
        filters: filtersPayload,
      },
    };

    console.log('🚀 Final Payload:', result);
    setLoading(true);
    try {
      const response = await apiServices.smartSequenceAudienceFilter(result);
      if (response.status === 200 || response.data?.success) {
        setLoading(false);
        toast.success('Audience filter applied successfully!', { position: 'top-right' });
        setFilteredResult(response.data);
      } else {
        toast.error('Failed to apply filter. Please try again.', {
          position: 'top-right',
        });
      }
    } catch (err) {
      toast.error('An unexpected error occurred.', {
        position: 'top-right',
      });
      console.error(err);
    }
  };

  useEffect(() => {
  if (formData?.audienceFilter?.filters?.length) {
    // Deep clone and create editable rows
    const prefilledRows = formData.audienceFilter.filters.map((filterItem) => {
      const matchedColumn = filteredColumnDefs.find(
        (col) => col.field.toLowerCase() === filterItem.fieldName.toLowerCase()
      );

      const matchedOperator = filter2.find(
        (op) => op.label.toLowerCase() === filterItem.conditionOperator.toLowerCase()
      );

      let fieldValues = {};

      if (matchedColumn?.type === 'checkbox') {
        fieldValues.emailOptOut = filterItem.filterValue === 'true';
      } else if (matchedColumn?.type === 'dropdown') {
        const dropdownList = matchedColumn.data || [];
        const matchedItem = dropdownList.find(
          (item) =>
            item.displayName === filterItem.filterValue ||
            item.display_name === filterItem.filterValue ||
            item.name === filterItem.filterValue
        );
        if (matchedItem) {
          fieldValues[`${matchedColumn.field}Id`] = matchedItem.id || matchedItem.userId;
        }
      } else {
        fieldValues[matchedColumn?.field] = filterItem.filterValue;
      }

      return {
        selectedOption: matchedColumn
          ? {
              value: matchedColumn.field,
              label: matchedColumn.headerName,
              originalData: { ...matchedColumn }, // ✅ deep clone to make editable
            }
          : null,
        isSelectedOption: !!matchedColumn,
        selectedFilterType: matchedOperator
          ? {
              id: matchedOperator.id,
              label: matchedOperator.label,
              value: matchedOperator.value,
            }
          : null,
        fieldValues,
      };
    });

    // ✅ Use functional update to preserve interactivity
    setFilterRows((prev) => {
      // only overwrite if there are no manually added rows yet
      if (!prev.some((row) => row.isSelectedOption)) {
        return prefilledRows;
      }
      return prev;
    });
  }
}, [formData]);


  return (
    <Formik initialValues={formData}>
      <Form>
        <div className="formBlock" style={{ height: 'calc(100vh - 190px)' }}>
          <div className="frmHdr">
            <h2>Filter Builder</h2>
          </div>

          <div className="counterBlock">
            <p>{filteredResult || 0} Records</p>
          </div>

          <div className="formContent filterBlk mt-3">
            {filterRows.map((row, index) => (
              <div className="row mb-3" key={index}>
                {/* Field Select */}
                <div className="col-12 col-sm-6 col-md-6 col-lg-4">
                  <label htmlFor="filter1"></label>
                  <label htmlFor="filter1"></label>
                  <Select
                    value={row.isSelectedOption ? row.selectedOption : null}
                    options={filteredColumnDefs.map((data) => ({
                      value: data.field,
                      label: data.headerName,
                      originalData: data,
                    }))}
                    onChange={(selectedOption) => handleSelection(selectedOption, index)}
                    placeholder="Select Field"
                  />
                </div>

                {/* Condition Operator */}
                <div className="col-12 col-sm-6 col-md-6 col-lg-3">
                  <label htmlFor="filter2"></label>
                  <Select
                    id={`conditionOperator-${index}`}
                    name="conditionOperator"
                    value={
                      row.selectedFilterType
                        ? filter2.find((option) => option.value === row.selectedFilterType.value)
                        : null
                    }
                    onChange={(selectedOption) => {
                      handleChange(selectedOption, 'conditionOperator', index);
                    }}
                    options={filter2}
                    placeholder="Select"
                    menuPortalTarget={document.body}
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        borderRadius: '5px',
                        borderColor: state.isFocused ? '#365397' : base.borderColor,
                        borderWidth: '1px',
                        boxShadow: state.isFocused ? '0 0 5px rgba(0, 86, 179, 0.3)' : 'none',
                        transition: 'border-color 0.3s ease, box-shadow 0.3s ease',
                        '&:hover': { borderColor: '#365397' },
                      }),
                      menu: (base) => ({
                        ...base,
                        borderRadius: '5px',
                        zIndex: 99999,
                      }),
                      menuPortal: (base) => ({
                        ...base,
                        zIndex: 99999,
                      }),
                      option: (base, state) => ({
                        ...base,
                        backgroundColor: state.isFocused ? '#365397' : base.backgroundColor,
                        color: state.isFocused ? '#fff' : base.color,
                        cursor: 'pointer',
                      }),
                    }}
                  />
                </div>

                {/* Value Input */}
                <div className="col-11 col-sm-11 col-md-11 col-lg-4">
                  {row.selectedOption && row.isSelectedOption ? (
                    row.selectedOption.originalData.type === 'text' ? (
                      <input
                        type="text"
                        placeholder={`Enter ${row.selectedOption.label}`}
                        value={row.fieldValues[row.selectedOption.value] || ''}
                        onChange={(e) => handleInputChange(e, row.selectedOption.value, index)}
                        className="form-control mt-2"
                      />
                    ) : row.selectedOption.originalData.type === 'dropdown' ? (
                      <>
                        <label htmlFor="filter3"></label>
                        <Select
                          options={
                            row.selectedOption.originalData.data?.map((data) => ({
                              value: data.id || data.userId,
                              label: data.displayName || data.display_name,
                            })) || []
                          }
                          onChange={(selected) =>
                            handleDropdownChange(selected, `${row.selectedOption.value}Id`, index)
                          }
                          placeholder={`Select ${row.selectedOption.label}`}
                        />
                      </>
                    ) : row.selectedOption.originalData.type === 'checkbox' ? (
                      <div className="form-check mt-2">
                        <input
                          type="checkbox"
                          name="emailOptOut"
                          checked={row.fieldValues.emailOptOut || false}
                          onChange={(e) => handleChangeCheckbox(e, index)}
                          className="form-check-input"
                        />
                        <label className="form-check-label">Email Opt Out</label>
                      </div>
                    ) : (
                      <input
                        type="number"
                        placeholder={`Enter ${row.selectedOption.label}`}
                        value={row.fieldValues[row.selectedOption.value] || ''}
                        onChange={(e) => handleInputChange(e, row.selectedOption.value, index)}
                        className="form-control mt-2"
                      />
                    )
                  ) : null}
                </div>

                {/* Remove Button */}
                <div className="col-1 col-sm-1 col-md-1 col-lg-1">
                  <button
                    type="button"
                    className="btn btn-link text-danger mt-2"
                    onClick={() => handleRemoveFilter(index)}
                  >
                    <img src={closeSqr} alt="remove" width={18} />
                  </button>
                </div>
              </div>
            ))}

            {formData?.type !== 'view' && (
              <>
                <button type="button" className="btn btn-outline-primary" onClick={handleAddFilter}>
                  <i className="bi bi-plus-lg"></i> Add Filter
                </button>

                <button type="button" className="btn btn-primary ms-2" onClick={handleApplyFilter}>
                  {loading && (
                    <>
                      {' '}
                      <div className="spinner-border spinner-border-sm me-2" role="status"></div>
                    </>
                  )}
                  {loading ? 'Loading...' : 'Apply Filter'}
                </button>
              </>
            )}
          </div>
        </div>
      </Form>
    </Formik>
  );
};

export default AudienceFilter;
